import { render, staticRenderFns } from "./AcademicSpecializations.html?vue&type=template&id=0785bab4&external"
import script from "./AcademicSpecializations.js?vue&type=script&lang=js&external"
export * from "./AcademicSpecializations.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports